// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// © Copyright Utrecht University (Department of Information and Computing Sciences)

import React from 'react'
import './InfoPage.css'
import '../../shared/shared.css'
import uuLogo from '../../images/uu-logo.svg'
import mebLogo from '../../images/meb-logo.svg'
import { useNavigate, Link } from 'react-router-dom'
import config from '../../config/config'

// Function based component rendering the info page
function InfoPage() {

  return (
    // Infopage components, contains article containers
    <div className="med-info-content">
      <section className="med-content-container">
        <h1>About the {config.header.title}</h1>
        <hr className="med-top-separator" />
        <p>
          The <strong>E</strong>uropean <strong>M</strong>edicines <strong>R</strong>egulatory <strong>D</strong>atabase (<strong>EMRD</strong>) is a free-to-access interactive dashboard that stores and
          displays daily-updated information on the regulation of medicines for human use in the European Union (EU).
          EMRD aggregates information from various regulatory sources and documents such as legal decisions, public
          assessment reports and drug labels to create a comprehensive database of how medicinal products for human use
          in the EU are regulated over the medicines life-cycle including key events such as orphan designations,
          marketing authorisation procedures and post-marketing drug regulatory actions.
        </p>
        <p>
          The intended use of EMRD is to
          support researchers studying drug development, regulation and use in fields such as drug regulatory science,
          drug innovation, clinical pharmacology and pharmaco-epidemiology. EMRD also intends to serve other
          stakeholders such as drug regulators, developers and patients as well as students who would like to learn more
          about the European drug regulatory system and regulation of individual medicines.
        </p>
      </section>

      <section className="med-content-container">
        <h1>Citing</h1>
        <p>
          We ask that users who make use of EMRD data as part of their research cite the EMRD manuscript in any
          resulting publications.
        </p>
        <p>
          -- insert reference here --
        </p>
      </section>

      <section className="med-content-container">
        <h2>About the team</h2>
        <hr className="med-top-separator" />
        <img
          src={mebLogo}
          alt="Logo of the Medicines Evaluation Board"
          className="med-institution-logo"
        />
        <img
          src={uuLogo}
          alt="Logo of the University of Utrecht"
          className="med-institution-logo"
        />

        <p className="med-institution-info">
          The EMRD project is a joint initiative of Utrecht University (UU) and the Dutch Medicines Evaluation Board
          (MEB). The project was initiated and is currently led by Dr. Lourens Bloem (UU), Dr. Jarno Hoekman (UU), Dr.
          Marjon Pasmooij (MEB), Stefan Verweij (MEB) and Vincent Haverhoek (UU).
        </p>
      </section>

      <section className="med-content-container">
        <h1>Acknowledgements</h1>
        <hr className="med-top-separator" />
        <p>
          Students from the bachelor Information Sciences organized in project team MedCTRL and MediSee have greatly
          contributed to the development of the dashboard as part of their Software Project course at the Utrecht
          University. We are also grateful to several other organizations that have supported EMRD and contributed
          to bringing it alive.


        </p>
      </section>

      <section className="med-content-container">
        <h1>License</h1>
        <p>
          All data and metadata downloadable from this dashboard are licensed under a <a href="https://creativecommons.org/licenses/by/4.0/">
            Creative Commons Attribution 4.0 International
          </a>
          . Data is maintained and managed using FAIR principles.
        </p>
      </section>

      <section className="med-content-container">
        <h1>Release notes</h1>
        <p>
          Version 1.0 of the European Medicines Regulatory Database was released on XXXXX 2025.
        </p>
      </section>
      <section className="med-content-container">
        <h1>Disclaimer</h1>
        <p>
          The contents of EMRD are intended for educational and scientific research purposes only. Every effort has
          been made to ensure the accuracy and completeness of the information that is provided on this website.
          However, Utrecht University and the Dutch Medicines Evaluation Board make no warranties regarding errors
          in the data, and assume no responsibility for the use of the EMRD.
        </p>
      </section>
      <section className="med-content-container">
        <h1>Contact or report issue</h1>
        <p>
          To contact us, please email at [email address].
        </p>
      </section>
    </div>
  )
}

export default InfoPage
